module.exports = __webpack_public_path__ + "img/IMG_9674-2.78961d61.png";